// extracted by mini-css-extract-plugin
export default {"landing-section":"Landing_landing-section__taNWK","landing-article":"Landing_landing-article__cy2dN","landing-heading":"Landing_landing-heading__bE2lC"};